// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App'
import router from './router'
import AgoraRTC from 'agora-rtc-sdk'
import AgoraRTM from 'agora-rtm-sdk'
import axios from 'axios'

Vue.use(ElementUI);
// Vue.use(axios)
Vue.config.productionTip = false;
Vue.prototype.AgoraRTC = AgoraRTC;
Vue.prototype.AgoraRTM = AgoraRTM;
Vue.prototype.$http = axios;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js